import React, { createContext, useContext, useEffect, useState } from 'react';

interface ConsentContextType {
  hasCookieConsent: boolean;
  setCookieConsent: (consent: boolean) => void;
  showConsentBanner: boolean;
  dismissConsentBanner: () => void;
}

const ConsentContext = createContext<ConsentContextType | undefined>(undefined);

export function ConsentProvider({ children }: { children: React.ReactNode }) {
  const [hasCookieConsent, setHasCookieConsent] = useState<boolean>(false);
  const [showConsentBanner, setShowConsentBanner] = useState<boolean>(false);
  
  useEffect(() => {
    // Check if user has already given consent
    const storedConsent = localStorage.getItem('syncdit-cookie-consent');
    if (storedConsent === 'true') {
      setHasCookieConsent(true);
      setShowConsentBanner(false);
    } else if (storedConsent === null) {
      // Only show the banner if we haven't asked before
      setShowConsentBanner(true);
    }
  }, []);
  
  const setCookieConsent = (consent: boolean) => {
    setHasCookieConsent(consent);
    localStorage.setItem('syncdit-cookie-consent', consent.toString());
    setShowConsentBanner(false);
  };
  
  const dismissConsentBanner = () => {
    setShowConsentBanner(false);
  };
  
  const value = {
    hasCookieConsent,
    setCookieConsent,
    showConsentBanner,
    dismissConsentBanner
  };
  
  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

export function useConsent() {
  const context = useContext(ConsentContext);
  if (context === undefined) {
    throw new Error('useConsent must be used within a ConsentProvider');
  }
  return context;
} 